export default __webpack_public_path__ + "graphics/camera.9ee7502f.png";